import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { InstantSearch, Hits } from 'react-instantsearch/dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'

class SetName extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: ''
    }
  }

  handleSubmit = () => {
    let currentComponent = this

    let randomNumberID = Math.floor(Math.random() * 100) + 1

    //console.log('https://api.dsnapis.com/insert/1/pw/teSt1/filterid/'+randomNumberID+'/filtername/'+this.state.name+'/dschigh/5/dsclow/1/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/0/clrhigh/5/clrlow/1')
    console.log(
      'https://api.dsnapis.com/insert/2/pw/teSt1/filterid/' +
        randomNumberID +
        '/filtername/' +
        this.state.name +
        '/dschigh/5/dsclow/1/agehigh/' +
        this.props.agehigh +
        '/agelow/' +
        this.props.agelow +
        '/oarhigh/' +
        this.props.oarhigh +
        '/oarlow/' +
        this.props.oarlow +
        '/herprefage/' +
        this.props.old_age +
        '/herprefans/' +
        this.props.pref_fans +
        '/clrhigh/5/clrlow/1'
    )
    axios({
      method: 'post',
      url:
        'https://api.dsnapis.com/insert/2/pw/teSt1/filterid/' +
        randomNumberID +
        '/filtername/' +
        this.state.name +
        '/dschigh/5/dsclow/1/agehigh/' +
        this.props.agehigh +
        '/agelow/' +
        this.props.agelow +
        '/oarhigh/' +
        this.props.oarhigh +
        '/oarlow/' +
        this.props.oarlow +
        '/herprefage/' +
        this.props.old_age +
        '/herprefans/' +
        this.props.pref_fans +
        '/clrhigh/5/clrlow/1',
      data: {}
    }).then(function(response) {
      currentComponent.props.changeRoute('/console/search/saved_searches')
    })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  render() {
    const { classes, theme, location } = this.props
    return (
      <div className={classes.root}>
        <InstantSearch
          appId="latency"
          apiKey="3d9875e51fbd20c7754e65422f7ce5e1"
          indexName="bestbuy"
        >
          <TextField
            id="SearchByName"
            label="Name for your saved search"
            className={classes.textField}
            value={this.state.name}
            onChange={this.handleChange('name')}
            margin="normal"
          />
          <Button
            raised
            color="primary"
            align="center"
            onClick={() => this.handleSubmit()}
            className={classes.button}
          >
            Save
          </Button>
        </InstantSearch>
      </div>
    )
  }
}

//https://api.dsnapis.com/insert/1/pw/teSt1/filterid/30/filtername/Search POST TEST 30, Age 44-52, OAR 8-10, All DSC/dschigh/5/dsclow/1/agehigh/52/agelow/44/oarhigh/10/oarlow/8/herprefage/50/herprefans/0/clrhigh/5/clrlow/1

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    agelow: state.age.low,
    agehigh: state.age.high,
    oarlow: state.oar.low,
    oarhigh: state.oar.high,
    old_age: state.old_age,
    pref_fans: state.pref_fans
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(SetName)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/SetName/index.js